const qs = require('query-string');

export const getQs = () => {
  return qs.parse(window.location.search)
}